import React, { useState } from 'react';
import { CFormTextarea, CButton, CSpinner, CFormLabel, CFormInput, CBadge } from '@coreui/react';
import { EditIcon, X } from 'lucide-react';

const DiagnosisDetails = ({ keywords, setKeywords, label = "Keywords", editMode = false }) => {
    const [textInput, setTextInput] = useState('');

    const handleInputChange = (event) => {
        setTextInput(event.target.value);
    };

    const [editIndex,setEditIndex] = useState(null);

    // const handleKeyPress = (event) => {
    //     if (event.key === 'Enter' && textInput.trim()) {
    //         const newKeywords = textInput
    //             .split(',')
    //             .map(keyword => keyword.trim())
    //             .filter(keyword => keyword); // Filter out any empty keywords
    //         setKeywords([...keywords, ...newKeywords]);
    //         setTextInput('');
    //     }
    // };


    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && textInput.trim()) {
            if (editIndex !== null) {
                const updatedKeywords = [...keywords];
                updatedKeywords[editIndex] = textInput.trim();
                setKeywords(updatedKeywords);
                setEditIndex(null);
            } else {
                // Add new keywords if not in edit mode
                const newKeywords = textInput
                    .split(',')
                    .map(keyword => keyword.trim())
                    .filter(keyword => keyword);
                setKeywords([...keywords, ...newKeywords]);
            }
            setTextInput('');
        }
    };


    const handleEditKeyword = (index) => {
        setTextInput(keywords[index]);
        setEditIndex(index);
    };

    // const handleEditKeyword = (index) => {
    //     const selectedKeyword = keywords[index];
    //     setTextInput(selectedKeyword); // Set input with the selected keyword
    //     setKeywords(keywords.filter((_, i) => i !== index)); // Remove it from the list
    // };

    const handleRemoveKeyword = (index) => {
        setKeywords(keywords.filter((_, i) => i !== index));
    };

    const handleBadgeClick = (index) => {
        if (editMode) {
            handleEditKeyword(index);
        } else {
            handleRemoveKeyword(index);
        }
    };

    return (
        <div>
            <CFormLabel>{label}</CFormLabel>
            <CFormInput
                type="text"
                placeholder={`Type and press Enter to add ${label}`}
                value={textInput}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                name='assessment'
            />
            <div style={{ marginTop: '10px' }}>
                {Array.isArray(keywords) && keywords.map((keyword, index) => (
                    <CBadge
                    key={index}
                    color={editIndex === index ? "warning" : "primary"}
                    className="me-1"
                    style={{ cursor: 'pointer' }}
                    // onClick={() => handleBadgeClick(index)}
                >
                    {keyword}
                    <span onClick={()=>handleEditKeyword(index)} className='px-1'><EditIcon strokeWidth={1} size={15} /></span>
                    <span 
                    onClick={()=>{
                        const filteredKeywords = keywords.filter((_,idx)=>idx !== index)
                        setKeywords(filteredKeywords)
                    }}
                    className='px-1'><X strokeWidth={1} size={15} /></span>
                </CBadge>
                ))}
            </div>
        </div>
    );
};

export default DiagnosisDetails;
